import {Flex, Image, Segmented} from 'antd'
import {Link} from 'react-router-dom'
import {ButtonLinkLike} from '../buttons/ButtonLinkLike'
import {$app, $t} from '../../app'
import {useEffect, useState} from 'react'

import logoHexaColor from '../../gfx/logo-trails-of-ice-and-fire-color.png'
import logoSimpleColor from '../../gfx/logo-trails-of-ice-and-fire-simple-color.svg'

export function Header({menuActive, setMenuActive}) {
  const [activeLang, setActiveLang] = useState()

  useEffect(() => {
    setActiveLang($app.$language())
  }, [activeLang])

  const closeMobileMenu = () => {
    setMenuActive(false)
  }

  return (
    <div className="header-wrapper">
      <header className="main-header">
        <div className="main-header-logo">
          <Link to="/">
            <Image src={logoSimpleColor} preview={false}/>
          </Link>
        </div>
        <div className="right-side">

          <Segmented
            className="desktop-only"
            options={[{value: 'cs-CZ', label: 'Čeština'}, {value: 'en-US', label: 'English'}]}
            value={activeLang}
            onChange={(value) => {
              $app.$language(value)
              setActiveLang(value)
              window.location.reload()
            }}/>

          <svg className={`ham mobile-only ${menuActive && 'burger'}`} viewBox="0 0 100 100" width="80" onClick={() => {
            setMenuActive(!menuActive)
          }}>
            <path className="line top" d="m 30,35 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20"/>
            <path className="line middle" d="m 30,50 h 40"/>
            <path className="line bottom" d="m 70,65 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20"/>
          </svg>

        </div>

        <nav className="desktop-only">
          <Flex justify="center" align="center" style={{height: 'inherit'}}>
            <Link to="/"><ButtonLinkLike>
              <$t _="home"/>
            </ButtonLinkLike></Link>
            <Link to="/who-we-are"><ButtonLinkLike>
              <$t _="who_we_are"/>
            </ButtonLinkLike></Link>
            <ButtonLinkLike>
              <$t _="guide"/>
            </ButtonLinkLike>
            <Link to="/events"><ButtonLinkLike>
              <$t _="book_trip"/>
            </ButtonLinkLike></Link>
          </Flex>
        </nav>
      </header>
      <nav className={`mobile-nav ${menuActive && 'active'}`}>
        <Flex justify="center" align="center" vertical style={{height: 'inherit'}} gap="2.34em">
          <Link to="/" onClick={closeMobileMenu}><ButtonLinkLike data-before="01" className={`${menuActive && 'active'}`}>Home</ButtonLinkLike></Link>
          <Link to="/who-we-are" onClick={closeMobileMenu}><ButtonLinkLike className={`${menuActive && 'active'}`}>
            <$t _="who_we_are"/>
          </ButtonLinkLike></Link>
          <Link to="/online-guide" onClick={closeMobileMenu}><ButtonLinkLike className={`${menuActive && 'active'}`}>Guide</ButtonLinkLike></Link>
          <Link to="/events" onClick={closeMobileMenu}><ButtonLinkLike className={`${menuActive && 'active'}`}>Book trip</ButtonLinkLike></Link>
          <Segmented
            options={[{value: 'cs-CZ', label: 'Čeština'}, {value: 'en-US', label: 'English'}]}
            value={activeLang}
            onChange={(value) => {
              $app.$language(value)
              setActiveLang(value)
              window.location.reload()
            }}/>
        </Flex>
      </nav>
    </div>
  )
}